import React from 'react';
import { COMMENT_BOX_PLACEHOLDER_TEXT } from '../../../../common/constants/data-hooks';
import { PlaceholderTooltip } from './placeholder-tooltip';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../../api-provider';
import { st, classes } from './placeholder-text.st.css';
export const PlaceholderText = ({ text }) => {
    const isTooltipEnabled = React.useRef(false);
    const containerNode = React.useRef(null);
    const textNode = React.useRef(null);
    const isMobile = useApi(getIsMobile);
    React.useEffect(() => {
        if (containerNode.current &&
            textNode.current &&
            containerNode.current.getBoundingClientRect().width <
                textNode.current.getBoundingClientRect().width) {
            isTooltipEnabled.current = true;
        }
    }, [text]);
    return (React.createElement(PlaceholderTooltip, { className: st(classes.root, { isMobile }), isEnabled: isTooltipEnabled.current, tooltip: React.createElement("div", { className: classes.tooltip }, text) },
        React.createElement("div", { ref: containerNode, className: classes.textContainer },
            React.createElement("span", { className: classes.comparisonNode, ref: textNode }, text),
            React.createElement("span", { "data-hook": COMMENT_BOX_PLACEHOLDER_TEXT }, text))));
};
//# sourceMappingURL=placeholder-text.js.map